import { configureStore as configureToolkitStore } from '@reduxjs/toolkit'
import rootReducer from '../reducers'

export default function configureStore() {
  const store = configureToolkitStore({
    reducer: rootReducer,
    devTools: __DEV__ // Use built-in Redux DevTools instead of Reactotron for web
  })

  return { store }
}
